import { PropsWithChildren } from "react";
import { Layout } from "~/components/layout";
import { ProfileModal } from "~/components/modal/profile-modal";
import { SessionContext, useAuth } from "~/contexts/auth-context";
import { TrendsContextProvider } from "~/contexts/trends-context";
import { TermsAcceptanceOverlay } from "~/pages/login/components/terms-acceptance-overlay";
import { ProjectsContextProvider } from "~/pages/projects/contexts/projects-context";

export function AppLayout({ children }: PropsWithChildren) {
  const { session } = useAuth();

  // Signing out clears the session before the guard redirects to the login page.
  if (!session) {
    return null;
  }

  return (
    <SessionContext value={session}>
      <TrendsContextProvider>
        <ProjectsContextProvider>
          <Layout>
            {children}
            <ProfileModal />
          </Layout>
        </ProjectsContextProvider>
      </TrendsContextProvider>
      <TermsAcceptanceOverlay />
    </SessionContext>
  );
}
